function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16 24a8 8 0 110-16 8 8 0 010 16z",
  fill: "#2DB35C"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.699 19.261l4.819-4.82a.962.962 0 00-1.359-1.36l-4.14 4.141-2.178-2.179a.962.962 0 00-1.36 1.36l2.858 2.858a.957.957 0 001.36 0z",
  fill: "#fff"
});

var SvgIconCirCheckHighlighted = function SvgIconCirCheckHighlighted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDI0QzExLjU4MTYgMjQgOCAyMC40MTg0IDggMTZDOCAxMS41ODE2IDExLjU4MTYgOCAxNiA4QzIwLjQxODQgOCAyNCAxMS41ODE2IDI0IDE2QzI0IDIwLjQxODQgMjAuNDE4NCAyNCAxNiAyNFoiIGZpbGw9IiMyREIzNUMiLz4KPHBhdGggZD0iTTE1LjY5ODkgMTkuMjYxMkwyMC41MTc5IDE0LjQ0MDZDMjAuODk0OCAxNC4wNjUyIDIwLjg5MzggMTMuNDU2NiAyMC41MTc5IDEzLjA4MTFDMjAuMTQzNCAxMi43MDYyIDE5LjUzMzkgMTIuNzA2MiAxOS4xNTkgMTMuMDgxMUwxNS4wMTkyIDE3LjIyMkwxMi44NDEyIDE1LjA0MzRDMTIuNDY1OCAxNC42Njg1IDExLjg1NjcgMTQuNjY4NSAxMS40ODE4IDE1LjA0MzRDMTEuMTA2MyAxNS40MTg5IDExLjEwNjMgMTYuMDI4NCAxMS40ODE4IDE2LjQwMjlMMTQuMzM5NSAxOS4yNjEyQzE0LjUyNzUgMTkuNDQ5MiAxNC43NzMxIDE5LjU0MjkgMTUuMDE5MiAxOS41NDI5QzE1LjI2NTMgMTkuNTQyOSAxNS41MTEgMTkuNDQ5MiAxNS42OTg5IDE5LjI2MTJaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgIconCirCheckHighlighted as ReactComponent };